(() => {
  // --- One-time patching (so theme/app code can't yank scroll) ---
  if (!window.__guNoScrollPatched) {
    window.__guNoScrollPatched = true;

    const original = {
      scrollIntoView: Element.prototype.scrollIntoView,
      scrollTo: window.scrollTo,
      scrollBy: window.scrollBy,
      focus: HTMLElement.prototype.focus,
    };

    // Global state
    window.__guNoScrollState = {
      armed: false,
      savedY: 0,
      savedX: 0,
      restoreTimer: null,
      disarmTimer: null,
    };

    // Patch scrollIntoView
    Element.prototype.scrollIntoView = function (...args) {
      if (window.__guNoScrollState.armed) return;
      return original.scrollIntoView.apply(this, args);
    };

    // Patch scrollTo / scrollBy
    window.scrollTo = function (...args) {
      if (window.__guNoScrollState.armed) return;
      return original.scrollTo.apply(this, args);
    };

    window.scrollBy = function (...args) {
      if (window.__guNoScrollState.armed) return;
      return original.scrollBy.apply(this, args);
    };

    // Patch focus() to prevent scroll jumps
    HTMLElement.prototype.focus = function (options) {
      if (window.__guNoScrollState.armed) {
        try {
          return original.focus.call(this, { preventScroll: true });
        } catch (e) {
          // Older browsers: just call focus normally
          return original.focus.call(this);
        }
      }
      return original.focus.call(this, options);
    };
  }

  const state = window.__guNoScrollState;

  // Where a user-initiated variant change can occur in your theme
  const isVariantInteraction = (el) => {
    if (!el) return false;
    return !!el.closest(
      'variant-selects, variant-radios, .product-form__input, .product-form__input--pill, .product-form__input--swatch, .product-form__input--dropdown'
    );
  };

  const arm = (e) => {
    const t = e.target;
    if (!isVariantInteraction(t)) return;

    // Save scroll position immediately
    state.armed = true;
    state.savedY = window.scrollY || window.pageYOffset || 0;
    state.savedX = window.scrollX || window.pageXOffset || 0;

    // Clear any previous timers
    if (state.disarmTimer) clearTimeout(state.disarmTimer);

    // Fail-safe: disarm even if no variant event fires
    state.disarmTimer = setTimeout(() => {
      state.armed = false;
    }, 1500);
  };

  const restoreScroll = () => {
    // Restore multiple times because Dawn updates DOM/media in phases
    const x = state.savedX;
    const y = state.savedY;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        window.scrollTo(x, y);
        setTimeout(() => window.scrollTo(x, y), 60);
        setTimeout(() => window.scrollTo(x, y), 180);
      });
    });
  };

  // Arm BEFORE change happens (best chance to block the yank)
  document.addEventListener('pointerdown', arm, true);
  document.addEventListener('touchstart', arm, true);
  document.addEventListener('mousedown', arm, true);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === ' ') arm(e);
  }, true);

  // When variant actually changes, restore and disarm shortly after
  document.addEventListener(
    'variant:change',
    () => {
      if (!state.armed) return;

      restoreScroll();

      // disarm after restore
      setTimeout(() => {
        state.armed = false;
      }, 300);
    },
    true
  );
})();
